import { StateToken } from '@ngxs/store';

import { LocalesData } from '@shared/models/locale.model';

export interface LocalesStateModel {
  locales: LocalesData;
}

export const LOCALES_STATE_TOKEN = new StateToken<LocalesStateModel>('locales');
